import { ProcessingOverlay } from '@components'

import { BorderRadius, Color, FilesPreview, FileType, PreviewFile, SkeletonBox } from '@billy/design-system'
import { ReactElement, useEffect, useMemo, useState } from 'react'

import { getClassName } from '../../../../utils/getClassName'
import { DEFAULT_ZOOM_LEVEL } from '../../constants/defaultZoomLevel'
import { getInitialPreviewZoom } from '../../utils/getInitialPreviewZoom'
import * as Styled from './styles'

const DOCUMENT_PREVIEW_INITIAL_HEIGHT = 1122
const DOCUMENT_PREVIEW_INITIAL_WIDTH = 794

interface DocumentHtmlPreviewProps {
  htmlFiles: string[] | undefined
  isLoading?: boolean
}

export const DocumentHtmlPreview = ({ htmlFiles = [], isLoading }: DocumentHtmlPreviewProps): ReactElement => {
  const [currentZoom, setCurrentZoom] = useState(DEFAULT_ZOOM_LEVEL)

  const previewFiles: PreviewFile[] = useMemo(() => htmlFiles.map((file) => ({ src: file })), [htmlFiles])

  useEffect(() => {
    const initialZoom = getInitialPreviewZoom()

    setCurrentZoom(initialZoom)
  }, [])

  if (previewFiles.length === 0) {
    return (
      <Styled.PreviewSkeletonBoxWrapper zoom={currentZoom}>
        <SkeletonBox height={DOCUMENT_PREVIEW_INITIAL_HEIGHT} width={DOCUMENT_PREVIEW_INITIAL_WIDTH} />
      </Styled.PreviewSkeletonBoxWrapper>
    )
  }

  return (
    <Styled.FilesPreviewWrapper>
      {isLoading && previewFiles.length > 0 && (
        <ProcessingOverlay borderRadius={BorderRadius.R16} color={Color.White} withAnimation />
      )}
      <FilesPreview
        asType={FileType.Html}
        className={getClassName('dark-theme-suspend')}
        files={previewFiles}
        fitToHeight
        withPagination={false}
        zoomScale={currentZoom}
      />
    </Styled.FilesPreviewWrapper>
  )
}
